import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import { SpecialServicesDetailsModal } from './Modals/SpecialServicesDetailsModal';
import { useState } from 'react';
import { FormSectionWrapper } from './FormSectionWrapper';
import { useNotifications } from '../contexts/NotificationsContext';

const SERVICES_WITH_DETAILS = ['DRY_ICE', 'ALCOHOL', 'BATTERY', 'HOLD_AT_LOCATION', 'DANGEROUS_GOODS', 'HOME_DELIVERY_PREMIUM'];

export const SpecialServices = ({ shortcutVersion, formik, inMpsModal, isReturnShipmentTab }) => {
    const { addNotification } = useNotifications();
    const [modalFormData, setModalFormData] = useState({});
    const [show, setShow] = useState(false);
    const [modalServiceType, setModalServiceType] = useState('');
    const [modalServiceCode, setModalServiceCode] = useState('');
    const values = isReturnShipmentTab ? formik.values.returnData : formik.values;
    const isMps = values.mpsPackages.length > 0;

    const updateModalFormData = (newData) => {
        setModalFormData(newData);
    }

    const handleClose = () => setShow(false);
    const handleShow = (specialServiceCode) => {
        const obj = values.specialServices.find((i) => i.code === specialServiceCode);
        if (obj.details) {
            setModalFormData(obj.details);
        }
        if (!obj.details && obj.specialServiceType === 'BATTERY') {
            setModalFormData({ ...modalFormData, batteryRegulatoryType: 'IATA_SECTION_II' });
        }
        setShow(true);
    };

    const handleCheckChange = (e) => {
        const { value, checked } = e.target;
        const specialServicesField = isReturnShipmentTab ? 'returnData.specialServices' : 'specialServices';
        let selectedSpecialService;
        const updatedSpecialServices = values.specialServices.map((item) => {
            if (item.code === value) {
                selectedSpecialService = item.specialServiceType;
                return { ...item, selected: checked };
            } else {
                return item;
            }
        });
        formik.setFieldValue(specialServicesField, updatedSpecialServices);
        if ((checked === true) && SERVICES_WITH_DETAILS.includes(selectedSpecialService)) {
            setModalServiceType(selectedSpecialService);
            setModalServiceCode(value);
            handleShow(value);
        } else if ((checked === true) && !SERVICES_WITH_DETAILS.includes(selectedSpecialService)) {
            addNotification(`Alert for ${selectedSpecialService}`, 'The selected special service may require additional details that are not currently supported by this application.', 'info');
        }
    }

    const handleViewEditButton = (value, code) => {
        setModalServiceType(value);
        setModalServiceCode(code);
        handleShow(code);
    }

    return (
        <>
            {
                shortcutVersion ?
                    (isMps && !inMpsModal) ? <p>Please select Special Services on the Multiple-piece Shipment dialog</p> :
                    values.specialServices.map((i, index) => (
                        <Form.Check
                            key={i.code || `${i.specialServiceType}_${index}`}
                            type='checkbox'
                            id={i.code}
                            name={i.displayText || i.value}
                            value={i.code}
                            label={`${i.displayText || i.value}${i.subType ? (' - ' + i.subType) : ''}`}
                            onChange={handleCheckChange}
                            checked={i.selected}
                        />
                    ))
                    :
                    <FormSectionWrapper title='FedEx Special Services'>
                        {isMps ? <p>Please select Special Services on the Multiple-piece Shipment dialog</p> :
                        <Table>
                            <tbody>
                                {values.specialServices.map((i, index) => (
                                    <tr key={i.code || `${i.specialServiceType}_${index}`}>
                                        <td>
                                            <Form.Check
                                                type='checkbox'
                                                id={i.code}
                                                name={i.displayText || i.value}
                                                value={i.code}
                                                onChange={handleCheckChange}
                                                checked={i.selected}
                                            />
                                        </td>
                                        <td>{`${i.displayText || i.value}${i.subType ? (' - ' + i.subType) : ''}`}</td>
                                        <td>{SERVICES_WITH_DETAILS.includes(i.specialServiceType) ?
                                            <Button variant='secondary' size='sm' onClick={() => handleViewEditButton(i.specialServiceType, i.code)}>
                                                View/Edit
                                            </Button> : ''}</td>
                                    </tr>
                                ))
                                }
                            </tbody>
                        </Table>
                        }
                    </FormSectionWrapper>
            }
            <SpecialServicesDetailsModal
                formik={formik}
                show={show}
                handleClose={handleClose}
                serviceType={modalServiceType}
                serviceCode={modalServiceCode}
                formData={modalFormData}
                setFormData={updateModalFormData}
                isReturnShipmentTab={isReturnShipmentTab}
            />
        </>
    )
}